<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>My Coaches - {{username}} <span class="badge">{{totalRecords}}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button> -->
                <!-- (click)="addNewHomePageVideo()" -->
                <button class="exportBTn" (click)="exportExcel()"> <span><img
                            src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button>
                <button (click)="addCoach()" class="addBTn"> <span><img
                            src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add new
                    coach</button>
            </div>
        </div>
        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <button class="searchFilterBtn" (click)="searchFilter()">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>

                    </li>
                </ul>

            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table #dt [value]="coachList" [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'"
                        styleClass="p-datatable-striped" class="p2-table-columns show-columns" [lazy]="true"
                        (onLazyLoad)="loadCoachDetails($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption">
                        <!-- HEADER -->
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pSortableColumn="firstName" class="NameTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Coach Name
                                        <p-sortIcon field="firstName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="designationName" class="genderTd">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Role
                                        <p-sortIcon field="designationName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="mobileNumber" class="AgeTd">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Phone No.
                                        <p-sortIcon field="mobileNumber"></p-sortIcon>
                                    </div>
                                </th>
                                <!-- <th pSortableColumn="email" class="emailTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Email Id
                                        <p-sortIcon field="email"></p-sortIcon>
                                    </div>
                                </th> -->
                                <th pSortableColumn="status" class="statusTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Status
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="actionTD p-frozen-column">
                                    Action
                                </th>
                            </tr>
                            <tr>
                                <th [ngSwitch]="fullName" class="NameTD">
                                    <input pInputText type="text" [(ngModel)]="fullName"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'fullName', 'contains')"
                                        [value]="dt.filters['fullName'] ? dt.filters['fullName'].value : ''" />
                                </th>
                                <th [ngSwitch]="designationName" class="genderTd">
                                    <input pInputText type="text" [(ngModel)]="designationName"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'designationName', 'contains')"
                                        [value]="dt.filters['designationName'] ? dt.filters['designationName'].value : ''" />
                                </th>
                                <th [ngSwitch]="mobileNumber" class="AgeTd">
                                    <input pInputText type="text" [(ngModel)]="mobileNumber"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                                        [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                                </th>
                                <th [ngSwitch]="status" class="statusTD">
                                    <p-dropdown #pDropDownId [options]="statuses" [(ngModel)]="defaultStatus"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Status" appendTo="body"
                                        [showClear]="true">
                                        <ng-template let-option pTemplate="item">
                                            <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th class="actionTD p-frozen-column"></th>
                            </tr>
                        </ng-template>

                        <!-- BODY -->
                        <ng-template pTemplate="body" let-coach>
                            <tr>
                                <td>{{ coach?.fullName }}</td>
                                <td>{{ coach?.designationName }}</td>
                                <td>{{ coach?.mobileNumber }}</td>
                                <!-- <td>{{ coach.email }}</td> -->
                                <td class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap  ' : 'show-col text-nowrap col-200'">
                                    <div class="swichTable">
                                        <p-inputSwitch [(ngModel)]="coach.status" (onChange)="changeStatus(coach)"
                                            class="d-flex"></p-inputSwitch>
                                        <div class="label activeText" *ngIf="coach.status">
                                            Active
                                        </div>
                                        <div class="label InActiveText" *ngIf="!coach.status">
                                            Inactive
                                        </div>
                                    </div>

                                    <!-- <p-inputSwitch [(ngModel)]="academyTournament.status"
												(onChange)="changeStatus(academyTournament)"></p-inputSwitch> -->
                                </td>
                                <td class="action-col">
                                    <ul class="actionList">
                                        <li>
                                            <button (click)="editCoach(coach?.id)" class="editBtn"><img
                                                    src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                        </li>
                                        <li>
                                            <button (click)="deleteCoach(coach)" class="deleteBtn"><img
                                                    src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                        </li>
                                        <!-- <li>
                                            <p-splitButton icon="pi pi-ellipsis-h" [model]="coach.items" appendTo="body"
                                                styleClass="moreBtn" pTooltip="More Options " tooltipPosition="bottom"
                                                (onClick)="listMenus(coach.id)"></p-splitButton>
                                        </li> -->
                                    </ul>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No coach found.</td>
                            </tr>
                        </ng-template>
                    </p-table>

                </div>
            </div>
        </div>
    </div>
</div>


<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>